export default "__VITE_ASSET__2c10ef7b__"